import { api } from "./api";

import { postFetch } from "./request";

const commonModel = {
    // 初始化接口
    init: async (Data) => {
        const success = await postFetch(api.init, Data);
        return success;
    },
    // 获取服务器时间
    time: async (Data) => {
        const success = await postFetch(api.time, Data);
        return success;
    },
    // 发送短信
    info: async (Data) => {
        const success = await postFetch(api.info, Data);
        return success;
    },
    // 获取文章列表
    articles: async (Data) => {
        const success = await postFetch(api.articles, Data);
        return success;
    },
    // 获取栏目列表
    columns: async (Data) => {
        const success = await postFetch(api.columns, Data);
        return success;
    },
    // 获取栏目扩展字段
    additi: async (Data) => {
        const success = await postFetch(api.additi, Data);
        return success;
    },
    // 立即预约
    reserve: async (Data) => {
        const success = await postFetch(api.reserve, Data);
        return success;
    },
    // 获取预约礼包
    giftLog: async (Data) => {
        const success = await postFetch(api.giftLog, Data);
        return success;
    },
    //获取预约里程碑数据
    milestone: async (Data) => {
        const success = await postFetch(api.milestone, Data);
        return success;
    },
    //根据ip获取区号
    getAreaCode: async (Data) => {
        const success = await postFetch(api.areaCode, Data);
        return success;
    },
    // 获取活动信息
    getActivityInfo: async (Data) => {
        const success = await postFetch(api.activityInfo, Data);
        return success;
    }
}
export default commonModel;
